import Vue from 'vue'
import Element from 'element-ui'
import '../assets/styles/element-variables.scss'
// @ts-ignore
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(Element, { locale })
